module.exports = __webpack_public_path__ + "static/raducu-roman-0bbadeefbeed36ec2505d9ba76f85ed1.jpg";